<template>
  <v-container fluid tag="section" class="pa-3">
    <v-card class="white mb-2 pa-3 rounded-lg elevation-0" :loading="loading">
      <v-row>
        <v-col cols="12" md='2'>
          <v-select
            :items="[{ text: '按年月日', value: 1 },{ text: '按时间区间', value: 2 }]"
            label="查询类型"
            v-model="searchType"
            hide-details='auto'
            outlined dense
            @change="chageSearchType"
            clear-icon="mdi-close-circle-outline"
          ></v-select>
        </v-col>
        <v-col cols="12" md='3' v-if="searchType === 1">
          <v-select-search
            hide-details
            outlined dense
            label="年份选择"
            :data='yearItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            multiple
            v-model='form.years'>
          </v-select-search>
        </v-col>
        <v-col cols="12" md='2' v-if="searchType === 1">
          <v-select-search
            hide-details
            outlined dense
            label="月份选择"
            :data='monthItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            multiple
            class="ml-n4"
            v-model='form.months'>
          </v-select-search>
        </v-col>
        <v-col cols="12" md='3' v-if="searchType === 2">
          <base-material-date
            hide-details
            range
            label='时间区间'
            clearable
            dense outlined
            @on-change="loadData"
            v-model="form.createTimes"
            clear-icon="mdi-close-circle-outline"
          >
          </base-material-date>
        </v-col>
        <v-col cols="12" md='2' class="mt-c-1">
          <v-btn color="primary" :loading="loading" class="px-2" @click="loadData"><v-icon>mdi-magnify</v-icon>查询</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <div class="rounded-lg white pa-3">
      有效贡献 = 回款总额 - 其他费用 - 居间总额
    </div>
    <div v-for="(data, idx) in List" :key="idx" class="my-2">
      <v-card class="mx-auto elevation-0 py-3">
        <v-card-title class="py-1">{{data.deptName}}
          <v-spacer></v-spacer>
          <span class="primary--text size-15">{{data.statusVal}}</span>
        </v-card-title>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="mb-2 size-15"> 合同数：{{data.signNumber}} </v-list-item-title>
            <v-list-item-subtitle class="mb-3">
              <v-row>
                <v-col cols="12" md='3'>
                  合同总额：<span class="size-20 blue--text">{{data.signPrice}}</span>
                </v-col>
                <v-col cols="12" md='3'>
                  回款总额：<span class="size-20 green--text">{{data.returnMoney}}</span>
                </v-col>
                <v-col cols="12" md='3'>
                  居间总额：<span class="size-20 cyan--text">{{data.mediatorPrice}}</span>
                </v-col>
                <v-col cols="12" md='3'>
                  其他费用：<span class="size-20 orange--text">{{data.otherPrice}}</span>
                </v-col>
                <v-col cols="12" md='6'>
                  有效贡献：<span :class="`size-20 ${data.profferPrice >= 0 ? 'teal' : 'red'}--text`">{{data.profferPrice.toFixed(2)}}</span>
                </v-col>
              </v-row>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn color="grey" small text @click="show(idx, data)">
            <v-icon>{{ idx === showIdx ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ idx === showIdx ? '关闭明细' : '合同明细' }}
          </v-btn>
        </v-card-actions>
          <v-expand-transition>
            <v-card v-if="idx === showIdx" elevation="0" class="pa-1">
              <base-material-table outlined :item="item" class="elevation-1" ref="table" single-expand>
                <template v-slot:condition>
                  <v-col cols="12" md='2' class="pr-2 pb-0 pt-c-10 px-0">
                    <base-marerial-user-select @on-change="loadList"  label='用户选择(负责人)' hide-details dense outlined v-model="item.params.userIds" mid :menu='$constants.SysMenu.CONTRACT_M_ID'></base-marerial-user-select>
                  </v-col>
                </template>
                <template v-slot:expanded-content="{ headers, item, refresh }">
                    <td :colspan="headers.length" v-if='refresh' class="px-0">
                      <v-divider v-if="$isMobile"></v-divider>
                      <contract-view mini :item='item' lazy></contract-view>
                    </td>
                  </template>
              </base-material-table>
            </v-card>
          </v-expand-transition>
      </v-card>
    </div>
  </v-container>
</template>

<script>
  import VSelectSearch from '@/components/select/v-select-search.vue'
  import { total } from '@/api/statis/proffter.js'
  import { selectData2, selectMonthData } from '@/utils/tool.js'
  import ContractView from '@/views/pages/pc/contract/info/components/Detail.vue'

  export default {
    name: 'StatisProffer',
    components: {
      VSelectSearch,
      ContractView
    },
    data() {
      return {
        List: [],
        form: {},
        showIdx: -1,
        loading: false,
        searchType: 1,
        searchDateMenu: false,
        monthItems: selectMonthData(),
        yearItems: selectData2(),
        item: {
          mobile: true,
          path: 'proffter/list',
          params: {
            did: '',
            months: [],
            years: [],
            userIds: [],
            createTimes: []
          },
          sort: {
            orderByField: 'con.create_time',
            asc: false
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.table[0].showMore(row, idx)
                }
              }
            },
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              mobile: true,
              width: 200,
              copy: true,
              value: 'customerName',
              sortable: false,
              formatter: (val) => val || '--',
              search: { type: 'input', mobile: true }
            },
            {
              text: '产品名称',
              align: 'center',
              divider: true,
              width: 210,
              copy: true,
              value: 'productName',
              sortable: false,
              formatter: (val) => val || '--'
            },
            {
              text: '合同额',
              align: 'center',
              divider: true,
              width: 100,
              value: 'signPrice',
              sortable: false,
              formatter: (val) => val || 0
            },
            {
              text: '回款额',
              align: 'center',
              divider: true,
              width: 100,
              value: 'returnMoney',
              sortable: false,
              formatter: (val) => val || 0
            },
            {
              text: '居间费',
              align: 'center',
              divider: true,
              width: 100,
              value: 'mediatorPrice',
              sortable: false,
              formatter: (val) => val || 0
            },
            {
              text: '其他费用',
              align: 'center',
              divider: true,
              width: 100,
              value: 'otherPrice',
              sortable: false,
              formatter: (val) => val || 0
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              width: 210,
              copy: true,
              mobile: true,
              value: 'serialNumber',
              sortable: false,
              formatter: (val) => val || '--',
              search: { type: 'input', mobile: true }
            },
            {
              text: '签订人',
              align: 'center',
              width: 150,
              divider: true,
              value: 'signUserList',
              mobile: true,
              sortable: false,
              formatter: (val) => {
                let name = ''
                val.forEach(item => {
                  name += `${item.name}|`
                })
                return name.substring(0, name.lastIndexOf("|"))
              }
            },
            {
              text: '签订时间',
              align: 'center',
              value: 'signTime',
              width: 120,
              sortable: false,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '有效贡献',
              align: 'center',
              divider: true,
              width: 100,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              value: 'profferPrice',
              sortable: false,
              formatter: (val) => val || 0
            },
          ]
        }
      }
    },
    methods: {
      show (idx, data) {
        this.showIdx = this.showIdx === idx ? -1 : idx
        this.item.params.did = data.did
        this.item.params.years = this.form.years
        this.item.params.months = this.form.months
        this.item.params.createTimes = this.form.createTimes
      },
      chageSearchType () {
        this.item.params.years = []
        this.item.params.months = []
        this.item.params.createTimes = []
        this.form = {}
        this.loadData()
      },
      loadList () {
        this.$nextTick(function() {
          this.$refs.table[0].loadData()
        })
      },
      loadData () {
        this.loading = true
        total(this.form).then(res => {
          if (res.status === 200) {
            this.List = res.data
            this.showIdx = -1
          }
          this.loading = false
        })
      }
    },
    created () {
      this.loadData()
    }
  }
</script>

<style>
</style>
